export type ActPhotoType =
  | 'RESULT'
  | 'LABEL'
  | 'DESIGN_REF'
  | 'SKIN_CHECK'
  | 'BEFORE'
  | 'HEALING'
  | 'CONSENT_FORM'
  | 'JEWELRY'
  | 'CLIENT_ID';

export type IdPhotoSide = 'front' | 'back';

export interface ActPhoto {
  id: string;
  type: ActPhotoType;
  takenAt: string;
  url: string; // endpoint to stream the file
}

export interface IdPhoto {
  id: string;
  side: IdPhotoSide;
  takenAt: string;
  url: string;
}

export const ACT_PHOTO_TYPE_LABELS: Record<ActPhotoType, string> = {
  RESULT: 'Résultat',
  LABEL: 'Traçabilité (étiquettes)',
  DESIGN_REF: 'Référence design',
  SKIN_CHECK: 'Vérification peau',
  BEFORE: 'Avant',
  HEALING: 'Cicatrisation',
  CONSENT_FORM: 'Formulaire de consentement',
  JEWELRY: 'Bijou choisi',
  CLIENT_ID: "Pièce d'identité",
};

export const ID_PHOTO_SIDE_LABELS: Record<IdPhotoSide, string> = {
  front: 'Recto',
  back: 'Verso',
};
